import Panel from 'components/panel/panel'
import Stars from 'components/stars/stars'
import styles from './review.module.scss'
import { nl2br, cn } from 'utils/helpers'

export default function Review({ item, useBorder }) {
    const Component = useBorder ? 'div' : Panel
    return (
        <Component className={cn(styles.review, useBorder && styles.useBorder, 'mb36')}>
            <div className={cn(styles.top, 'mb24')}>
                <Stars number={item.stars} className={styles.stars} />
                <div className={styles.right}>
                    {item.name}
                    {item.name ? ', ' : ''}
                    {item.date}
                </div>
            </div>
            <div
                className={styles.text}
                dangerouslySetInnerHTML={{
                    __html: nl2br(item.content)
                }}
            />
        </Component>
    )
}
